export const LastNameOnCardFieldData = {
  formControlName: 'lastNameOnCard',
  id: 'grit-field-last-name-on-card',
  type: 'text',
  label: 'Last name (on card)',

  validationList: [
    {
      errorKey: 'cannotContainNumbers',
      message: 'Your last name cannot contain any numbers.',
    },
    {
      errorKey: 'startWithALetter',
      message: 'Your last name must start with a letter.',
    },
    {
      errorKey: 'pattern',
      args: ["^[a-zA-Z '-]+$"],
      message:
        "Your last name can't contain any numbers or special characters other than dash (-), apostrophe(') or a space.",
    },
  ],
  requiredMessage: 'Your last name is required to process your card.',
};
